import { z } from 'zod';
import { shipLineCaptureInputSchema } from '../validation/sales-order/ship-line-capture-input.js';
import { uniqueLineList } from '../validation/sales-order/unique-line-list.js';
import { requiredClientGeneratedUuidString, requiredUuidString, } from '../validation/zod-helpers/index.js';
// The all-rejected refusal needs the shipped quantities, so the resolver checks it against the order's lines.
export const markSalesOrderDeliveredInputSchema = z.object({
    salesOrderId: requiredUuidString('Sales order is required.', 'Invalid sales order selection.'),
    idempotencyKey: requiredClientGeneratedUuidString('Mark Delivered key is required.', 'Invalid Mark Delivered key.'),
    capture: uniqueLineList(shipLineCaptureInputSchema),
});
//# sourceMappingURL=mark-delivered-input.js.map